$(function  () {

  // VARIABLES
  const feedback = $('.js-feedback')
  const prev = $('.js-feedback-prev')
  const next = $('.js-feedback-next')

  const isSimple = feedback.hasClass('js-simple')
  const slidesToShow = isSimple ? 1 : 2

  feedback.slick({
    dots: false,
    dotsClass: 'pill',
    infinite: true,
    speed: 300,
    slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: prev,
    nextArrow: next,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

});
